import { TvService } from 'models'

/**
 * A TvId object which consists of id and purchase eligiblement
 * @typedef {Object} TvId
 * @property {String} id - user's TV id
 * @property {String} purchaseEligible - yes or no
 */

/**
 * Response from /api/v1/account/mapping/{essoid}
 * @typedef {Object} MappingResponse
 * @property {String} essoId - user's esso id
 * @property {Array<TvId>} tvId
 */

/**
 * Creates array of users's TV ids from backend response
 * @param {MappingResponse}
 * @returns {Array<TvService>} returns essoid and array of tv ids
 *  if user have not tv ids, returns an empty array
 */
export const tvServiceFactory = ({ essoId, tvId } = {}) => {
    if (!essoId && !tvId) return []
    if (!tvId) {
        // If there is no TV ID available, then the ESSOID is the unique Service
        return [
            new TvService({
                serviceId: essoId,
                serviceType: 'ESSOID',
                name: 'Main service', // Give more intelligible name because data could be sensitive. BTW auto login SHALL be trigger in the UI without TV service display
                parentAccountId: essoId,
            }),
        ]
    }
    return tvId.map(
        ({ id, purchaseEligible }) =>
            new TvService({
                serviceId: id,
                serviceType: 'TVID',
                purchaseEligible: returnBoolFromYesOrNo(purchaseEligible),
                name: id,
                parentAccountId: essoId,
            })
    )
}

/**
 * Returns true or false depending on 'yes' or 'no'
 * @param {String} expression - 'yes' or 'no'
 * @returns {Boolean} returns true if expression === 'yes' and false if 'no'
 */
const returnBoolFromYesOrNo = (expression = 'yes') => {
    return expression.toLowerCase() === 'yes'
}
